const selectedTagsArray = []

const selectors = {
  applyTriggers: '.cta-for-checkboxes',
  checkboxes: 'input[type="checkbox"]',
  checkboxContainers: '.filter-dropdown__checkboxes',
  dropdownBtns: '.filter-dropdown__button',
};

import axios from 'axios';
import hoverintent from 'hoverintent'

export default function init ({ el, context }) {
  const nodeSelectors = {
    applyTriggers: el.querySelectorAll(selectors.applyTriggers),
    checkboxContainers: el.querySelectorAll(selectors.checkboxContainers),
    checkboxes: el.querySelectorAll(selectors.checkboxes),
    dropdownBtns: el.querySelectorAll(selectors.dropdownBtns)
  };

  var currentURL = window.location.pathname.replace('/','').split('/');
  var collectionTags = currentURL[2];

  if(collectionTags){
    var collectionTagsArray = collectionTags.split('+')
    for (var i = collectionTagsArray.length - 1; i >= 0; i--) {
      selectedTagsArray.push(collectionTagsArray[i])
    }
  }

  const openDropdown = (dropdownBtn, index) => {
    dropdownBtn.classList.add("open");
    nodeSelectors.checkboxContainers[index].classList.add("visible");
  }

  const closeDropdown = () => {
    nodeSelectors.dropdownBtns.forEach((button, index, array) => {
      button.classList.remove("open");
      nodeSelectors.checkboxContainers[index].classList.remove("visible");
    })
    
  }

  const toggleDropdown = (dropdownBtn, index) => {
    if (dropdownBtn.classList.contains("open")) {
      closeDropdown()
    } else {
      closeDropdown()
      openDropdown(dropdownBtn, index)
    }
  }

  nodeSelectors.dropdownBtns.forEach((dropdownBtn, index) => {
    hoverintent(dropdownBtn, () => {
      openDropdown(dropdownBtn, index)
    }, () => {
      closeDropdown()
    });
  })
}


